import { Image, Table, Tag, Typography } from "antd"
import moment from "moment"
import { OrderAndPrefix } from "../../../components/Orders/Helpers/OrderAndPrefix"
import { useEffect, useState } from "react"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import "../../../styles/OrderTable.css"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { filterOrdersByRole } from "../../../utils/filterOrdersByRole"

const { Text } = Typography

export default function WinderTable({ currentKey, user }) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  const { admin, semiAdmin, devSpecialist } = useAuthContext()

  //fetch the data
  useEffect(() => {
    if (currentKey === 4.5) {
      setLoading(true)
      const ref = collection(db, "orders")
      let q = (admin || semiAdmin || devSpecialist)
        ? query(ref, where("orderStatus", "==", 5))
        : query(ref, where("orderStatus", "==", 5), where("uid", "==", user.uid))

      const unsubscribe = onSnapshot(q, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          const data = doc.data()
          results.push({ ...data, key: doc.id, id: doc.id })
        })
        setTimeout(() => {
          const filtered = filterOrdersByRole(results, { admin, semiAdmin, devSpecialist })
          setData(filtered)
          setLoading(false)
        }, 500)
      })

      return () => unsubscribe()
    }
  }, [currentKey, admin, semiAdmin, devSpecialist, user])

  //user filterr
  let userFilter =
    data &&
    data.reduce((accumulator, item) => {
      // Assuming "machine" data is under item.selectedProduct.machine
      const machineName = item.user
      const existingItem = accumulator.find((filterItem) => filterItem.value === machineName)

      if (!existingItem) {
        accumulator.push({
          text: machineName, // Assuming you have a function to get a friendly name for each machine
          value: machineName,
        })
      }

      return accumulator
    }, [])

  //client filter
  let clientFIlters =
    data &&
    data.reduce((accumulator, item) => {
      const clientName = item.client.client
      const existingItem = accumulator.find((filterItem) => filterItem.text === clientName)

      if (existingItem) {
        existingItem.value = clientName
      } else {
        accumulator.push({
          text: clientName,
          value: clientName,
        })
      }

      return accumulator
    }, [])

  let productFilters =
    data &&
    data.reduce((accumulator, item) => {
      const productName = item.selectedProduct.product.productName
      const existingItem = accumulator.find((filterItem) => filterItem.text === productName)

      if (existingItem) {
        existingItem.value = productName
      } else {
        accumulator.push({
          text: productName,
          value: productName,
        })
      }

      return accumulator
    }, [])

  //return correct manager
  const returnCorrectManager = (recordUser) => {
    if (recordUser !== user.email) {
      return <Tag>{recordUser}</Tag>
    } else {
      return <Tag color="#722ed1">{recordUser}</Tag>
    }
  }

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.orderNumber - b.orderNumber,
      render: (value, record) => OrderAndPrefix(record),
    },
    {
      title: "Manager",
      dataIndex: "user",
      align: "center",
      filters: userFilter,
      onFilter: (value, record) => record.user === value,
      filterSearch: true,
      render: (value, record) => {
        return returnCorrectManager(value)
      },
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      filters: clientFIlters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
    },

    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: productFilters,
      onFilter: (value, record) => record.selectedProduct.product.productName === value,
      filterSearch: true,
      render: (value, record) => {
        // Safely access changableSpace using optional chaining and logical OR
        const changableSpace = record.selectedProduct?.advanced?.changableSpace || false
        if (changableSpace) {
          return (
            <Text>
              {value} - ({record.changableSpaceData})
            </Text>
          )
        } else {
          return <Text>{value}</Text>
        }
      },
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Label Count",
      align: "center",
      render: (record) => {
        if (record.selectedProduct.machine === "Tape") {
          return <Text>{record.rollCount}</Text>
        } else {
          return <Text>{record.labelCount}</Text>
        }
      },
    },

    {
      title: "Technical",
      dataIndex: ["selectedProduct", "technicalPage"],
      align: "center",
      render: (value) => {
        return <Image src={value} width={25} height={25} />
      },
    },
    {
      title: "Due date",
      dataIndex: "orderDueDate",
      align: "center",
      sorter: (a, b) => a.orderDueDate.seconds - b.orderDueDate.seconds,
      render: (value) => <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>,
    },
    {
      title: "Created",
      dataIndex: "created",
      align: "center",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>,
    },
  ]

  return (
    <>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={loading}
        columns={defaultColumns}
        bordered
        dataSource={data}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
        rowClassName={(record) => (record.user === user.email ? "light-gray-background" : "")}
      />
    </>
  )
}
